import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { Link, useHistory, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
import GoogleMapComponentV2 from '../../../Global/GoogleMapComponentV2'
import ContentHeader from '../../../Layout/ContentHeader'
import { extractAddressComponents } from '../ReportWeb/components/Location/helpers/functions'
import {
  CREATE_WATER_TRUCK,
  GET_ALL_WATER_TRUCKS,
  GET_WATER_TRUCK_BY_ID,
  UPDATE_WATER_TRUCK,
} from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import { GET_ALL_PROVIDERS } from '../../../../graphql/Catalog/Providers/providers'
import {
  arrayStatus,
  fnObjNameStatus,
  fnStatusArrayCanSeeNewRequest,
} from '../../../../const/constStatuses_waterTruckRequest'
import { GET_ALL_COLONIES } from '../../../../graphql/Global/sepomex'
import { GET_CAPACITY_TRUCKS } from '../../../../graphql/Catalog/Trucks/trucks'

const validationSchema = Yup.object().shape({
  volume: Yup.string().required('Campo requerido'),
  priority: Yup.string().required('Campo requerido'),
  type_delivery: Yup.string().required('Campo requerido'),
  provider_id: Yup.string().required('Campo requerido'),
  status_id: Yup.string().required('Campo requerido'),
  address: Yup.string().nullable().required('Campo requerido'),
  comments: Yup.string().nullable(),
})

export const priorityOptions = [
  { value: 'normal', label: 'Normal' },
  { value: 'urgente', label: 'Urgente' },
]

export const typeDeliveryOptions = [
  { value: 'casa', label: 'Casa' },
  { value: 'cisterna', label: 'Cisterna' },
]

const statusOptionsNew = fnStatusArrayCanSeeNewRequest()
const allStatus = fnObjNameStatus()

const backPage = '/water-truck'

const WaterTruckRequestNewAndEdit = () => {
  const { id: _id } = useParams()

  const { showLoading, hideLoading } = useLoading()
  const history = useHistory()

  //STATES FOR GOOGLE MAPS
  const [coordinates, setCoordinates] = useState(null)
  const [isEditingMarkerPosition, setIsEditingMarkerPosition] = useState(false)
  const [address, setAddress] = useState(null)

  //OPTIONS
  const [providersOptions, setProvidersOptions] = useState([])
  const [coloniesOptions, setColoniesOptions] = useState([])
  const [colonySelected, setColonySelected] = useState(null)
  const [capacityOptions, setCapacityOptions] = useState([])

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const change_status_id = watch('status_id')

  const { loading, error, data, refetch } = useQuery(GET_WATER_TRUCK_BY_ID, {
    variables: { id: +_id },
    fetchPolicy: 'no-cache',
    skip: !_id,
  })

  const {
    loading: loadingProviders,
    error: errorProviders,
    data: dataProviders,
  } = useQuery(GET_ALL_PROVIDERS, {
    variables: {},
  })

  const {
    data: dataColonies,
    loading: loadingColonies,
    error: errorColonies,
  } = useQuery(GET_ALL_COLONIES, {
    fetchPolicy: 'cache-first',
  })

  const {
    data: dataCapacity,
    loading: loadingCapacity,
    error: errorCapacity,
  } = useQuery(GET_CAPACITY_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const [create] = useMutation(CREATE_WATER_TRUCK, {
    refetchQueries: [
      {
        query: GET_ALL_WATER_TRUCKS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const [update] = useMutation(UPDATE_WATER_TRUCK, {
    refetchQueries: [
      {
        query: GET_ALL_WATER_TRUCKS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  useEffect(() => {
    try {
      if (!_id) return
      if (loading) return
      if (error) throw error

      if (!data.getOneWaterTruckRequestById)
        throw new Error('No se encontró la estación de agua')

      const resp = data.getOneWaterTruckRequestById

      let addressData = {
        address: '',
        location: '',
      }
      if (resp?.AddressOfWaterTruckRequest !== null) {
        const respAdress = resp?.AddressOfWaterTruckRequest
        addressData.address = respAdress?.address_full
        addressData.location = `${respAdress?.latitude},${respAdress?.longitude}`
        setIsEditingMarkerPosition(addressData.location)
      }

      reset({
        volume: resp.volume,
        priority: resp.priority,
        provider_id: resp.provider_id,
        type_delivery: resp.type_delivery,
        status_id: resp.status_id,
        planning_date:
          resp.status_id === allStatus.planificar_pipa
            ? resp.planning_date
            : null,
        ...addressData,
        comments: resp.comments,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  useEffect(() => {
    try {
      if (loadingProviders) return
      if (errorProviders) throw errorProviders
      let list = []
      dataProviders.getAllProviders.rows.map((provider) => {
        return list.push({
          value: provider.id,
          label: `${provider.card_name} - ${provider.rfc}`,
        })
      })
      setProvidersOptions(list)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataProviders, errorProviders, loadingProviders])

  useEffect(() => {
    if (!loadingColonies && !errorColonies) {
      if (dataColonies) {
        const colonies = dataColonies.getAllColonies.map((item) => ({
          value: item.id,
          label: item.name,
          nocolonia: item.nocolonia,
        }))

        setColoniesOptions(colonies)
      }
    }
  }, [dataColonies, loadingColonies, errorColonies])

  useEffect(() => {
    if (coordinates) {
      const formattedCoordinates = `${coordinates.lat},${coordinates.lng}`
      setValue('location', formattedCoordinates)
    }else 
      setValue('location', null)
    

    if (address) {
      const getAddressComplete = address.formatted_address
      setValue('address', getAddressComplete)
    }
  }, [coordinates, address])

  useEffect(() => {
    if (!colonySelected) {
      setValue('colony_id', null)
    }
  }, [colonySelected])

  useEffect(() => {
    try {
      if (loadingCapacity) return
      if (errorCapacity) throw errorCapacity
      if (!dataCapacity)
        throw new Error('No se encontraron datos de las capacidades')

      const { getCapacityForTruck } = dataCapacity

      setCapacityOptions(getCapacityForTruck)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingCapacity, errorCapacity, dataCapacity])

  const onSubmit = async (Data) => {
    let addressInput = null

    if (address) {
      addressInput = {
        address_full: address.formatted_address,
        latitude: `${address.geometry.location.lat()}`,
        longitude: `${address.geometry.location.lng()}`,
        url_google_map: address?.url,
        street: '',
        zipcode: null,
        state: '',
        city: '',
      }

      if (address.address_components) {
        const { street, postalCode, state, city } = extractAddressComponents(
          address.address_components
        )
        addressInput.street = street
        addressInput.zipcode = +postalCode
        addressInput.state = state
        addressInput.city = city
      }

      if (coordinates) {
        addressInput.latitude = `${coordinates.lat}`
        addressInput.longitude = `${coordinates.lng}`
      }
    }

    let input = {
      volume: +Data.volume,
      priority: Data.priority,
      type_delivery: Data.type_delivery,
      provider_id: parseInt(Data.provider_id),
      status_id: parseInt(Data.status_id),
      comments: Data.comments,
    }

    if (!address?.zone_id) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Faltan datos de la zona',
      })
    }
    input.zone_id = address?.zone_id

    if (!address?.colony_name) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Falta la colonia',
      })
    }

    input.colony = {
      name: address?.colony_name,
      number: address?.colony_number,
    }

    if (change_status_id === allStatus.planificar_pipa) {
      if (!Data.planning_date) {
        return toastSweetAlert({
          mode: 'error',
          message: 'La fecha de planificación es requerida',
        })
      }

      input = { ...input, planning_date: Data.planning_date }
    }

    if (addressInput) {
      input = { ...input, address: addressInput }
    }

    showLoading()

    try {
      let message = ''

      if (_id) {
        await update({
          variables: { updateWaterTruckRequestId: parseInt(_id), input },
        })
        await refetch()
        message = 'Se actualizó con exito'
      } else {
        await create({ variables: { input } })
        message = 'Se creó con exito'
      }

      return toastSweetAlert({ mode: 'ok', message }, history.push(backPage))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                {/* <Link
                  className="btn btn-migrates-white mb-3"
                  to={backPage}
                >
                  <i className="fas fa-long-arrow-alt-left" /> Atrás
                </Link> */}
                <h1 className="header-title">Pipa de agua</h1>
              </div>
            </div>
          </div>
        }
        breadcrumb=""
        windowTitle={`${_id ? 'Editar' : 'Agregar'} pipa`}
      />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? 'Editar' : 'Agregar'} pipa`}
            btnSubmit
            clasCard="card report-water-truck-request"
            btnSubmitText={`${_id ? 'Guardar cambios' : 'Guardar'}`}
            btnRedPath={backPage}
            btnRedTxt="Cancelar"
            errors={errors}
            content={
              <>
                <div className="row">
                  {!_id && (
                    <div className="mb-3 col-12 col-sm-6">
                      <InputController
                        control={control}
                        name="volume"
                        label="Volumen"
                        inputType="choosen"
                        options={capacityOptions}
                        placeholderTxt="Selecciona un volumen"
                      />
                    </div>
                  )}
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      control={control}
                      name="priority"
                      label="Prioridad"
                      inputType="choosen"
                      options={priorityOptions}
                      placeholderTxt="Selecciona una prioridad"
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      control={control}
                      name="type_delivery"
                      label="Tipo de entrega"
                      inputType="choosen"
                      options={typeDeliveryOptions}
                      placeholderTxt="Selecciona un tipo"
                    />
                  </div>
                  {!_id && (
                    <>
                      <div className="mb-3 col-12 col-sm-6">
                        <InputController
                          control={control}
                          name="provider_id"
                          label="Proveedor"
                          inputType="choosen"
                          options={providersOptions}
                          placeholderTxt="Selecciona un proveedor"
                        />
                      </div>
                      <div className="mb-3 col-12 col-sm-6">
                        <InputController
                          control={control}
                          name="status_id"
                          label="Estatus"
                          inputType="choosen"
                          options={statusOptionsNew}
                          placeholderTxt="Selecciona estatus"
                        />
                      </div>
                    </>
                  )}
                  {change_status_id === allStatus.planificar_pipa && (
                    <div className="mb-3 col-12 col-sm-6">
                      <InputController
                        control={control}
                        inputType="text"
                        type="date"
                        name="planning_date"
                        label="Fecha de planificacion"
                        placeholderTxt="Selecciona una fecha"
                      />
                    </div>
                  )}
                  <div className="mb-3 col-12">
                    <InputController
                      control={control}
                      inputType="textarea"
                      name="comments"
                      label="Comentarios adicionales"
                      placeholderTxt="Escribe aquí"
                      rows={2}
                    />
                  </div>

                  <div className="mb-3 col-12">
                    <InputController
                      control={control}
                      name="colony_id"
                      label="Colocarse en una colonia"
                      inputType="choosen"
                      options={coloniesOptions}
                      placeholderTxt="Elige colonia"
                      isClearable={true}
                      valueManual={colonySelected}
                      changeAction={(e) => {
                        if (e?.value) return setColonySelected(e)

                        setCoordinates(null)
                        setAddress(null)
                        setValue('location', null)
                        setValue('address', null)
                        return setColonySelected('')
                      }}
                    />
                  </div>

                  <div className="mb-3 col-lg-12">
                    <InputController
                      control={control}
                      name="address"
                      label="Dirección"
                      disabled
                    />
                  </div>
                  <div className="mb-3 col-lg-12">
                    <InputController
                      control={control}
                      name="location"
                      label="Ubicación"
                      disabled
                    />
                  </div>
                  <div className="mb-3 col-12">
                    <label htmlFor="">Colonia</label>
                    <input
                      disabled={true}
                      type="text"
                      className="form-control rounded-2"
                      autoComplete="off"
                      value={address?.colony_name || ''}
                    />
                  </div>
                  <div className="mb-3 col-12 map-container">
                    <GoogleMapComponentV2
                      setCoordinates={setCoordinates}
                      address={address}
                      setAddress={setAddress}
                      isEditingMarkerPosition={isEditingMarkerPosition}
                      showInputAutocomplete={true}
                      colonySelected={colonySelected}
                      setColonySelected={setColonySelected}
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default WaterTruckRequestNewAndEdit
